import type { OfferSiteBundle } from "./offerSite";

const stack = [
  "Kubernetes, Helm, Rancher, Docker",
  "AWS (EKS, RDS, S3, Shield), Hetzner bare-metal",
  "Terraform, Ansible, GitLab CI",
  "Prometheus, Grafana, Loki, ELK",
  "Cloudflare WAF/DDoS, Vault, PCI DSS",
  "PostgreSQL, MongoDB, Ceph, RabbitMQ",
  "Ollama / vLLM, RAG (ChromaDB) — сұраныс бойынша",
];

const proof = [
  { brand: "Raiffeisen Bank", note: "AWS, PCI, audit CI/CD" },
  { brand: "Crypto exchange", note: "EKS, WAF, нодалар, vaults" },
  { brand: "Epicenter / 27.ua", note: "Highload, Ceph, кластер" },
  { brand: "DDoS", note: "100 Gbps / кейс ~10M pps" },
];

/** Қазақша: іскер стиль, IT-терминдер халықаралық қалады. Кириллица — KZ-да әлі негізгі. */
export const kk: OfferSiteBundle = {
  seoHome: {
    title: "Төлем, айырбас және highload инфрақұрылымы | IT-24.pro",
    description:
      "Инфрақұрылым инженери: DDoS, PCI DSS, Kubernetes, нодалар, vaults. Банк пен биржа тәжірибесі. Telegram, USDT/инвойс. Retainer $1 500/айдан.",
  },
  ui: { open: "Ашу", forWhom: "Кімге", includes: "Не кіреді" },
  nav: {
    services: "Қызметтер",
    cases: "Кейстер",
    about: "Мен туралы",
    contacts: "Байланыс",
    telegramCta: "Telegramға жазу",
  },
  hero: {
    eyebrow: "IT-24.pro · айырбас · төлем · highload",
    h1: "Тоқтап қалса — ақша кететін инфрақұрылым",
    lead:
      "Биржа, төлем және жүктемесі жоғары сервистердің production-ын құрамын әрі ұстаймын: DDoS, PCI DSS, Kubernetes, құпиялар мен нодалар. Өзім істеймін — Telegram-да жауап беремін.",
    ctaTg: "Telegramға жазу",
    ctaOffers: "Қызметтер мен баға",
    chips: ["PCI DSS L1/L2", "DDoS 100+ Gbps", "USDT / PL инвойс", "2010 жылдан бері инфрақұрылымда"],
  },
  proofTitle: "Аты бар тәжірибе",
  proofLead: "Резюме мен кейстерден тексеруге болатын фактілер — «500+ жоба» жоқ.",
  proof: proof,
  offersTitle: "Қызметтер",
  offersLead: "Төрт формат. VPS пен «$80-ға админ» тарифтері жоқ.",
  offers: [
    {
      id: "incident",
      href: "/services/incident",
      title: "Шұғыл көмек",
      price: "$100–150/сағ · пакет $600-дан",
      blurb: "Сәтсіздік, DDoS немесе қол жеткізу жоғалғанда production-ды көтеремін.",
      bullets: ["Telegram-да реакция", "Инциденттен кейін талдау", "Абоненттік шартсыз"],
    },
    {
      id: "audit",
      href: "/services/audit",
      title: "Аудит 1–2 күн",
      price: "$300–600",
      blurb: "Инфрақұрылым тәуекелі, PCI DSS-ке дайындық және шабуылға төзімділік.",
      bullets: ["Жазбаша есеп", "Неден бастау", "30–60 мин қоңырау"],
    },
    {
      id: "retainer",
      href: "/services/retainer",
      title: "Retainer — инфрақұрылымды сүйемелдеу",
      price: "$1 500–2 500/ай",
      blurb: "Айырбас пен финтехке сыртқы DevOps: релиз, мониторинг, инцидент.",
      bullets: ["40–80 сағат эквиваленті", "Telegram-арна", "Қалпына келтіруі тексерілген бэкап"],
    },
    {
      id: "projects",
      href: "/services/projects",
      title: "Кілтке тапсырылатын жоба",
      price: "$3 000–8 000 fixed",
      blurb: "PCI DSS контуры, DDoS қорғанысы, миграция, Kubernetes пен CI/CD, нодалар мен құпия қоймасы.",
      bullets: ["2–4 апта", "Бекітілген баға", "Тапсыру құжаттамасы"],
    },
  ],
  payTitle: "Қалай төлейді",
  payItems: ["USDT (TRC-20)", "KZT", "Wise / Payoneer", "Польша инвойсы (VAT)"],
  payNote: "Польшадағы заңды тұлға — ЕО клиенттері мен USDT есеп айырысуына ыңғайлы.",
  howTitle: "Қалай бастаймыз",
  howSteps: [
    { t: "Telegram-ға хабар", p: "Қысқаша: не жанып тұр, стек, бюджет." },
    { t: "30 минуттық қоңырау", p: "Инцидент, аудит, retainer немесе бір жоба." },
    { t: "Аудит немесе пилот", p: "Кіші кіріс — жылдық келісімшартсыз." },
    { t: "Retainer немесе fixed", p: "Әрі қарай — сүйемелдеу немесе нәтижесі түсінікті жоба." },
  ],
  aboutTeaser: {
    title: "Игорь Косицын",
    text: "DevOps / MLOps, Konin (PL). Linux highload 2010-жылдардан, cloud-native соңғы жылдары. Заңды тұлға Польшада.",
    link: "Толығырақ",
  },
  footerTagline:
    "Айырбас, финтех және жоғары жүктемелі жүйелердің инфрақұрылымы. ТМД нарығы · PL заңды тұлға · Telegram.",
  footerEuNote: "EU нарығына — бөлек сайт",
  footerEuLink: "nexops.eu",
  casesPage: {
    seo: {
      title: "Кейстер: банк, биржа, DDoS, highload | IT-24.pro",
      description: "Мысалдар: PCI DSS, биржа инфрақұрылымы, шабуылдан қорғау, e-commerce highload.",
    },
    h1: "Кейстер",
    lead: "Міндет, не істедім, немен аяқталды.",
    labels: { problem: "Міндет", did: "Шешім", result: "Нәтиже" },
    items: [
      {
        title: "Криптобиржа: production және комплаенс",
        problem: "Қолмен релизсіз айырбас пен нода инфрақұрылымы, құпияларды бақылау керек болды.",
        did: "AWS EKS және bare-metal Kubernetes, Helm, GitLab CI, WAF, Ceph, нодалар, vaults, Ansible және Terraform.",
        result: "Қолмен әуресіз релиз, аудитке дайын контур, production-да сүйемелдеу.",
      },
      {
        title: "Raiffeisen: миграция және PCI DSS",
        problem: "Инфрақұрылымды көшіру және қаржы секторының аудит пен қолжетімділік талаптары.",
        did: "AWS-қа миграция, Kubernetes, CI/CD hardening, PCI DSS Level 1/2 дайындығына инфрақұрылым жағынан қатысу.",
        result: "Тексеруге дайындық және қайталанатын деплой.",
      },
      {
        title: "Жарнамалық іске қосу кезіндегі DDoS",
        problem: "Секундына ~10 млн пакетке дейін шың; дата-орталықтар шабуылды сүзген жоқ.",
        did: "L3–L7 сүзгі, маңызды сервистерді қорғалған контурға көшіру, мониторинг, резерв маршруттар.",
        result: "Шабуылдың бір айында аудиторияның шамамен 80%-ы қол жеткізе алды.",
      },
      {
        title: "E-commerce / ритейл, highload",
        problem: "Жүктеме шыңдары, жүздеген терабайт қойма, әртүрлі өңірден қолжетімділік.",
        did: "Nginx, MySQL, Ceph, кластерлер, кэш, Украина — Франция схемасы.",
        result: "Жүктемеде тұрақты жұмыс және деректерді қорғалған сақтау.",
      },
    ],
  },
  aboutPage: {
    seo: {
      title: "Мен туралы — Игорь Косицын, DevOps/MLOps | IT-24.pro",
      description: "Айырбас пен финтех инфрақұрылымының инженери. Польша, банк пен биржа, PCI DSS, DDoS, Kubernetes.",
    },
    h1: "Мен туралы",
    lead: "Игорь Косицын. DevOps / MLOps: инфрақұрылымды өзім жобалаймын әрі ұстаймын, сайтта «жиырма адамдық команда» жоқ.",
    body: [
      "Заңды тұлға Польшада (Konin). Бұрын Украинада инфрақұрылым құрдым: банк, ритейл, биржалар.",
      "Тоқтау немесе бұзу ақша мен тексеруге соғатын міндеттерді аламын: төлем, айырбас, шың жүктеме, PCI DSS-ке дайындық.",
      "ЕО клиенттерін nexops.eu-да жүргіземін. IT-24.pro — ТМД тапсырыс берушілеріне.",
    ],
    stackTitle: "Стек",
    stack: stack,
  },
  contactsPage: {
    seo: {
      title: "Байланыс — Telegram, USDT төлем | IT-24.pro",
      description: "Telegram @devops_it24. USDT, KZT, Польша инвойсы.",
    },
    h1: "Байланыс",
    lead: "Негізгі арна — Telegram. Өзім жауап беремін, тикет кезегі жоқ.",
    tgHint: "Қысқаша: стек және қазір не ауырады.",
    payTitle: "Төлем",
    payItems: ["USDT TRC-20", "KZT", "Wise / Payoneer", "PL инвойс (VAT)"],
    payNote: "Польшадағы заңды тұлға — ЕО клиенттері мен USDT үшін ыңғайлы.",
  },
  services: {
    incident: {
      id: "incident",
      path: "/services/incident",
      seo: {
        title: "Инфрақұрылым бойынша шұғыл көмек — инцидент және DDoS | IT-24.pro",
        description:
          "Шабуыл, компрометация немесе сервистің құлауынан кейін production-ды қалпына келтіру. $100–150/сағ немесе $600-дан пакет. Telegram.",
      },
      breadcrumb: "Шұғыл көмек",
      h1: "Шұғыл көмек",
      lead: "Production жатса — алдымен қолжетімділікті көтеремін, сосын себебін қараймын. Инцидент ортасында «Growth пакетін» таңдатпаймын.",
      price: "$100–150/сағ · инцидент пакеті $600-дан",
      forWhom: [
        "Айырбас, төлем және жарнама бюджеті бар сервистер",
        "Өз DevOps on-call жоқ",
        "Шабуыл, компрометация, қол жеткізуді жоғалту, дерекке қауіп",
      ],
      includes: [
        "Диагностика және қолжетімділікті қалпына келтіру",
        "Алғашқы hardening (қолжетімділік, firewall, айқын олқылықтар)",
        "Қысқа post-mortem: не болды және әрі қарай не түзету",
        "Келісім бойынша — аудитке немесе retainer-ге өту",
      ],
      cta: "Инцидент туралы Telegramға жазу",
    },
    audit: {
      id: "audit",
      path: "/services/audit",
      seo: {
        title: "Инфрақұрылым аудиті және PCI DSS дайындығы | IT-24.pro",
        description: "1–2 күндік аудит: қауіпсіздік, DDoS контуры, бұлт шоты, PCI DSS. $300–600.",
      },
      breadcrumb: "Аудит",
      h1: "Аудит 1–2 күн",
      lead: "Тәуекел анықтығы үшін төлейсіз — жылдық келісімшартсыз.",
      price: "$300–600 fixed",
      forWhom: [
        "PCI DSS немесе сыртқы аудитке дайындық",
        "Бұлт провайдеріндегі шот өсіп жатыр",
        "Контурдың шабуылға немесе шыңға төзімі түсініксіз",
      ],
      includes: [
        "Сәулет, қолжетімділік, бэкап, мониторинг шолуы",
        "Басымдық бойынша тәуекел тізімі",
        "Жою бюджетінің бағасы (retainer немесе жоба)",
        "Есеп бойынша қоңырау",
      ],
      cta: "Telegram-да аудитке тапсырыс",
    },
    retainer: {
      id: "retainer",
      path: "/services/retainer",
      seo: {
        title: "Айырбас пен финтехке DevOps retainer | IT-24.pro",
        description: "Айлық сүйемелдеу $1 500–2 500: релиз, мониторинг, инцидент, бэкап.",
      },
      breadcrumb: "Retainer",
      h1: "Retainer — инфрақұрылымды сүйемелдеу",
      lead: "$100 хостингпен емес, демалысы мен bus factor-ы бар Middle/Senior DevOps $2.7–5k/аймен салыстырыңыз.",
      price: "$1 500–2 500 / ай",
      forWhom: [
        "Айырбас, төлем, финтех немесе highload-өнім",
        "Клиент жобаларында өз DevOps-ы жоқ студия",
        "Тикет қызметі емес, Telegram-дағы жауапты адам керек",
      ],
      includes: [
        "Келісілген терезеде мониторинг және инцидент реакциясы",
        "Сағат лимитінде релиз, CI/CD және инфрақұрылым түзетулері",
        "Жаңарту, бэкап, қалпына келтіруді мерзімді тексеру",
        "Айына қысқа есеп: жасалғаны және тәуекел аймақтары",
      ],
      cta: "Telegram-да retainer талқылау",
    },
    projects: {
      id: "projects",
      path: "/services/projects",
      seo: {
        title: "PCI DSS, DDoS, Kubernetes — кілтке жобалар | IT-24.pro",
        description:
          "Бекітілген баға $3–8k: PCI DSS контуры, DDoS қорғанысы, миграция, Kubernetes пен CI/CD, нодалар мен vaults.",
      },
      breadcrumb: "Жобалар",
      h1: "Кілтке тапсырылатын жоба",
      lead: "Айлық «сағат» емес, 2–4 аптада түсінікті нәтиже керек болғанда.",
      price: "$3 000–8 000 fixed · 2–4 апта",
      forWhom: [
        "Инфрақұрылымды PCI DSS-ке дайындау",
        "Инциденттен кейін немесе іске қосу алдында DDoS / WAF контуры",
        "Миграция (бұлт ↔ bare-metal), нөлден Kubernetes, нодалар мен vaults",
      ],
      includes: [
        "Бастамас бұрын скоп және бекітілген баға",
        "IaC, құжаттама, қолжетімділікті тапсыру",
        "Қабылдау критерийлері (қолжетімділік, пайплайн, бэкаптан қалпына келтіру)",
        "Опция: іске қосқаннан кейін сүйемелдеу (retainer)",
      ],
      cta: "Жобаны Telegram-да сипаттау",
    },
  },
};
